.product-grid {
  max-width: 1600px;
  background-color: var(--color-white);
  margin: 0 auto;

  padding-bottom: 20px;

  .grid {
    visibility: hidden;

    &.show {
      visibility: initial;
    }

    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); // https://css-tricks.com/equal-width-columns-in-css-grid-are-kinda-weird/
    grid-row-gap: 20px;
    grid-column-gap: 20px;
    grid-auto-rows: 1fr;
    grid-auto-flow: row dense;

    @include breakpointMin('md') {
      grid-template-columns: 1fr 1fr 1fr;
    }

    @include breakpointMin('lg') {
      grid-template-columns: 1fr 1fr;
    }

    @include breakpointMin('xl') {
      grid-template-columns: 1fr 1fr 1fr;
    }

    &.forCol {
      @include breakpointMin('md') {
        grid-template-columns: 1fr 1fr 1fr;
      }

      @include breakpointMin('xl') {
        grid-template-columns: 1fr 1fr 1fr 1fr;
      }
    }

    ::slotted(*) {
      width: 100%;
      box-sizing: border-box;
      margin: 0px auto;
    }

    ::slotted(lilu-product-list-teaser) {
      overflow: hidden;
    }

    ::slotted(.small) {
      max-width: 320px;
    }

    ::slotted(.big) {
      max-width: calc(650px + (100% - 640px) / 2);
      grid-column: span 2;
    }

    ::slotted(.teaser-hidden) {
      display: none;
    }

    @include breakpointMax('xl') {
      ::slotted(.teaser-show-mobile) {
        display: block;
      }
    }
    @include breakpointMin('xl') {
      ::slotted(.teaser-show-desktop) {
        display: block;
      }
    }
  }
}
